import { useState } from "react";
import { toast } from "sonner";
import { LegalLayout, H2, P, Note } from "./LegalLayout";
import { FOUND_CONFIG, GREEN, contactTarget } from "./foundConfig";

const CATEGORIES = [
  "Account & Login",
  "Artist Profiles",
  "Uploading Music",
  "Scout & FOUND FIRST",
  "Scout Points",
  "Reporting Content",
  "Copyright",
  "Privacy",
  "Account Deletion",
  "Technical Problems",
  "Other",
];

export default function Support() {
  const t = contactTarget();
  const [form, setForm] = useState({ name: "", email: "", category: CATEGORIES[0], message: "" });

  const submit = (e) => {
    e.preventDefault();
    toast.success("Thanks — your request has been noted.", {
      description: "This support form is a demo; connect it to your ticketing/email to go live.",
    });
    setForm({ name: "", email: "", category: CATEGORIES[0], message: "" });
  };

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const field = "w-full bg-black/40 border border-stone-800 focus:border-[color:var(--g)] text-white text-[15px] px-4 py-3 outline-none transition-colors";

  return (
    <LegalLayout
      title="FOUND Support"
      description="Get help with your FOUND account, uploads, Scouting, reporting, privacy and more."
    >
      <P>
        Need help with FOUND? Choose a topic and send us a message. We aim to help with everything
        from account issues to uploads, Scouting and reporting.
      </P>

      <H2>Support topics</H2>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 mb-4">
        {CATEGORIES.map((c) => (
          <span key={c} className="font-manrope text-xs text-stone-400 border border-stone-800 px-3 py-2">{c}</span>
        ))}
      </div>

      <H2>Contact us</H2>
      <form onSubmit={submit} data-testid="found-support-form" className="space-y-4 mt-4" style={{ "--g": GREEN }}>
        <input data-testid="support-name" className={field} placeholder="Your name" value={form.name} onChange={set("name")} required />
        <input data-testid="support-email" type="email" className={field} placeholder="Your email" value={form.email} onChange={set("email")} required />
        <select data-testid="support-category" className={field} value={form.category} onChange={set("category")}>
          {CATEGORIES.map((c) => <option key={c} className="bg-stone-900" value={c}>{c}</option>)}
        </select>
        <textarea data-testid="support-message" rows={4} className={`${field} resize-none`} placeholder="How can we help?" value={form.message} onChange={set("message")} required />
        <button
          type="submit"
          data-testid="support-submit"
          className="inline-flex items-center gap-3 font-manrope font-semibold text-sm tracking-wider px-7 py-4 text-black"
          style={{ backgroundColor: GREEN }}
        >
          SEND MESSAGE
        </button>
      </form>

      <Note>
        {t.isEmail
          ? <>You can also email us directly at <a href={t.href} className="text-white underline">{t.href.replace("mailto:", "")}</a>.</>
          : <>A public support email will be shown here once configured. This form currently records requests visually and should be connected to your email/ticketing system before launch.</>}
      </Note>

      <P className="!mt-8">
        Operated by {FOUND_CONFIG.company} · {FOUND_CONFIG.location}
      </P>
    </LegalLayout>
  );
}
